.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-width: var(--form-max);
}

/* Widths by expected content (the `width` prop). Without it the field fills up to 720px. */
.field[data-width='xs'] {
  max-width: var(--field-xs);
}

.field[data-width='sm'] {
  max-width: var(--field-sm);
}

.field[data-width='md'] {
  max-width: var(--field-md);
}

.label {
  color: var(--ink);
  font: var(--t-body-strong);
}

.trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  width: 100%;
  height: var(--control-height);
  padding: 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  text-align: left;
  cursor: pointer;
}

.field[data-dense] .trigger {
  height: var(--control-height-dense);
}

.trigger[data-hovered] {
  border-color: var(--graphite);
}

.trigger[data-pressed] {
  background: var(--brand-tint);
}

.trigger[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

.field[data-invalid] .trigger {
  border-color: var(--status-error-fg);
  outline: 1px solid var(--status-error-fg);
  outline-offset: -2px;
}

.trigger[data-disabled] {
  background: var(--wash);
  color: var(--pencil);
}

.value[data-placeholder] {
  color: var(--pencil);
}

/* A small downward chevron drawn with borders, so no icon font is needed. */
.caret {
  flex: none;
  width: 6px;
  height: 6px;
  margin-top: -3px;
  border-right: 1.5px solid currentcolor;
  border-bottom: 1.5px solid currentcolor;
  transform: rotate(45deg);
}

.popover {
  min-width: var(--trigger-width);
  /* React Aria sets max-height to fit the viewport; scroll inside rather than overflow it. */
  overflow-y: auto;
  border-radius: var(--radius-float);
  background: var(--paper);
  box-shadow: var(--shadow-float);
}

.popover[data-entering] {
  animation: fade var(--dur) var(--ease);
}

.list {
  padding: var(--space-1);
  outline: none;
}

.item {
  display: flex;
  align-items: center;
  min-height: var(--row-height);
  padding: 0 var(--space-3);
  border-radius: var(--radius-control);
  font: var(--t-body);
  cursor: pointer;
  outline: none;
}

.item[data-focused] {
  background: var(--brand-tint);
}

.item[data-focus-visible] {
  outline: var(--focus-ring);
  outline-offset: -2px;
}

.item[data-selected] {
  font: var(--t-body-strong);
}

.item[data-disabled] {
  color: var(--pencil);
  cursor: default;
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  color: var(--ink);
  font: var(--t-small);
  font-weight: 600;
}

@keyframes fade {
  from {
    opacity: 0;
  }
}
